/* 🤖 this file was generated by svg-to-ts */
export const matIconLocalDining: {
  name: 'local-dining';
  data: string;
} = {
  name: 'local-dining',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m8.1 13.34 2.83-2.83L3.91 3.5a4.008 4.008 0 0 0 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"/></svg>`
};
